import { HIGHTLIGHT_CONFIG } from '../../config';
import { createHighlight } from '../../infra';

export const highlight = createHighlight(HIGHTLIGHT_CONFIG);
